import { render, staticRenderFns } from "./document-classification-select.vue?vue&type=template&id=28d4fa54"
import script from "./document-classification-select.vue?vue&type=script&lang=js"
export * from "./document-classification-select.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports